import styled, {css, keyframes, DefaultTheme} from "styled-components";
import {hexToRgba} from "../../../../themes/hex-to-rgba";
import {LinkToOfferBoxBase} from "../link-to-offer-base/link-to-offer-box-base";


const linkToOfferIconKeyframes = (props: {theme: DefaultTheme}) => keyframes`
    0% {
        transform: scale(0.9);
        box-shadow: 0 0 0 0 ${hexToRgba(props.theme.colors.brandPrimary, 0.5)};
    }
    60% {
        transform: scale(1);
    }
    80% {
        transform: scale(1);
        box-shadow: 0 0 0 35px ${hexToRgba(props.theme.colors.brandPrimary, 0)};
    }
    100% {
        transform: scale(0.9);
        box-shadow: 0 0 0 0 ${hexToRgba(props.theme.colors.brandPrimary, 0)};
    }
`;

export const LinkToOfferIconDefaultBox = styled(LinkToOfferBoxBase)`
    color: ${({theme}) => theme.colors.textDark};
    ${props => props.shouldAnimate ? css`animation: ${linkToOfferIconKeyframes} 1.2s infinite` : ''};
`;
